import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CardTitlePrimary } from '@design-system-coopeuch/web';
import { properties } from '../../../../../utils/properties';
import PreguntaEncuestaEstrellas from '../../../atoms/PreguntaEncuestaEstrellas';
import PreguntaEncuestaInput from '../../../atoms/PreguntaEncuestaInput';
import { WrapperPregunta } from '../styles';

const Pregunta1 = ({
  setBotonDisabled,
  calificacionEstrella,
  setCalificacionEstrella,
  respuestaTexto,
  setRespuestaTexto,
}) => {
  const [calificacionMaximaConTexto] = useState(5);

  useEffect(() => {
    if (
      calificacionEstrella > calificacionMaximaConTexto ||
      (calificacionEstrella > 0 && calificacionEstrella <= calificacionMaximaConTexto && respuestaTexto !== '')
    ) {
      setBotonDisabled(false);
    } else {
      setBotonDisabled(true);
    }
  }, [calificacionEstrella, respuestaTexto]);

  return (
    <WrapperPregunta>
      <div className="contenido">
        <CardTitlePrimary className="titulo" title={properties.encuestaSatisfaccion.titulo} />
        <div className="subtitulo">1 de 2 preguntas</div>
        <div className="pregunta">{properties.encuestaSatisfaccion.pregunta1Titulo}</div>
        <div>
          <PreguntaEncuestaEstrellas
            cantidad={7}
            setCalificacionEstrella={setCalificacionEstrella}
          />
        </div>
        {calificacionEstrella > 0 && (
          <PreguntaEncuestaInput 
            campoObligatorio={calificacionEstrella <= calificacionMaximaConTexto}
            respuestaTexto={respuestaTexto}
            setRespuestaTexto={setRespuestaTexto}
            maxLength={200}
            labelPrimario={properties.encuestaSatisfaccion.pregunta1Label1}
            labelSecundario={properties.encuestaSatisfaccion.pregunta2Label2}
            label={calificacionEstrella < 6 ? 1 : 2}
          />
        )}
      </div>
    </WrapperPregunta>
  );
};

Pregunta1.propTypes = {
  setBotonDisabled: PropTypes.func.isRequired,
  calificacionEstrella: PropTypes.number.isRequired,
  setCalificacionEstrella: PropTypes.func.isRequired,
  respuestaTexto: PropTypes.string.isRequired,
  setRespuestaTexto: PropTypes.func.isRequired
};

export default Pregunta1;
